"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logQPromiseIssuesAndSendAlerts = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _Raven = _interopRequireDefault(require("Raven"));

var sendAlerts = function sendAlerts(reason) {
  var ravenOpts = {
    tags: {
      isUnhandledPromiseRejection: true
    }
  };

  if (typeof reason === 'string') {
    _Raven.default.captureMessage(reason, ravenOpts);
  } else {
    _Raven.default.captureException(reason, ravenOpts);
  }

  if (window.newrelic) {
    window.newrelic.noticeError(reason, {
      isUnhandledPromiseRejection: true
    });
  }
};

var isObject = function isObject(it) {
  return (0, _typeof2.default)(it) === 'object' ? it !== null : typeof it === 'function';
};

var configured = false;

var logQPromiseIssuesAndSendAlerts = function logQPromiseIssuesAndSendAlerts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (configured) {
    console.error('[Q] issue logger already configured');
    return function () {};
  }

  configured = true;
  var _options$timeout = options.timeout,
      timeout = _options$timeout === void 0 ? 2000 : _options$timeout; // eslint-disable-next-line no-restricted-globals

  var rejections = new WeakMap(); // eslint-disable-next-line no-restricted-globals

  var timeoutIds = new Set([]);

  var handleUnhandledRejection = function handleUnhandledRejection(e) {
    e.preventDefault();
    var promise = e.promise;
    var reason = e.reason;

    if (isObject(promise)) {
      var timeoutId = setTimeout(function () {
        console.error('Unhandled Promise Rejection', reason);
        sendAlerts(reason, 'unhandled');
      }, timeout);
      timeoutIds.add(timeoutId);
      rejections.set(promise, {
        reason: reason,
        timeoutId: timeoutId
      });
    } else if (window.newrelic) {
      window.newrelic.addPageAction('q-v7-unhandled-non-object');
    }
  };

  var handleRejectionHandled = function handleRejectionHandled(e) {
    var promise = e.promise;

    if (isObject(promise) && rejections.has(promise)) {
      var _rejections$get = rejections.get(promise),
          timeoutId = _rejections$get.timeoutId;

      clearTimeout(timeoutId);
      timeoutIds.delete(timeoutId);
      rejections.delete(promise);
    }
  };

  window.addEventListener('unhandledrejection', handleUnhandledRejection);
  window.addEventListener('rejectionhandled', handleRejectionHandled);
  return function () {
    configured = false;
    window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    window.removeEventListener('rejectionhandled', handleRejectionHandled);
    timeoutIds.forEach(function (timeoutId) {
      return clearTimeout(timeoutId);
    });
  };
};

exports.logQPromiseIssuesAndSendAlerts = logQPromiseIssuesAndSendAlerts;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-7.44/js/handlers.js
// module id = 887
// module chunks = 5 6